<template>
	<div class="h_wk">
		<h1 class="h1">和平精英在线估值</h1>
		<div style="margin-top:20px;text-align: center;color: #fff;">
			<span class="btn-item" @click="ptLogin('wx')">VX登入</span>
			<span class="btn-item" @click="ptLogin('qq')">扣扣登入</span>
		</div>
		<div style="margin-top:20px auto;text-align: center;color: #fff;display: flex;align-items: center;justify-content: center;" v-show="!loading&&roleList.length>0">
			<span class="btn-item" @click="createImg()">{{showCreateLoading?'生成中':'生成图片'}}</span>
			<span class="btn-item"><colorPicker v-model="color"></colorPicker></span>
		</div>
		<div id="testImg" style="text-align: center;width: 80%;margin: 0 auto;"></div>
		<div class="loading-show" v-show="loading">请稍后...</div>
		<div class="h_main" v-show="!loading&&roleList.length>0" ref="capture" :style="allColor()">
			<div style="margin: 50px;">
				<div class="h_main_s clearfix" v-show="showShuiyin" id='logo'>
					<div class="h_main_s_logo fl">
						<img src="../images/logo.png">
					</div>
					<div class="h_main_s_yx fl">
						<img src="../images/h_yx.png">
					</div>
					<div class="h_main_s_bbq fl" v-if="qq.qq_hpjy"><span>{{qq.qq_hpjy}}</span></div>
					<div class="h_main_s_yx fl">
						<img src="../images/h_yx.png">
					</div>
				</div>
				<div v-for="item in roleList" :key="item.roleId" >
					<div :id="('roleItem_'+item.roleId)" style="padding: 10px 0;">
						<div class="h_main_m">
							<span class="span">{{item.roleName}} </span>
							<span class="span" v-for="text in item.roleText" :key="text">{{text}}</span>
						</div>
						<div class="h_main_m">
							<span v-for="tab in item.depotdetail.tabs" :key="(item.roleId+'_'+tab.tabId)">
								<span class="span" v-if="tab.count>0">{{tab.tabName}}-{{tab.count}}</span>
							</span>
							
						</div>
						<div class="h_main_m">
							<span class="span" v-if="item.yanse6>0">粉装-{{item.yanse6}}</span>
							<span class="span" v-if="item.taozhuang>0">套装-{{item.taozhuang}}</span>
						</div>
					</div>
					<div class="h_main_x" 
						:style="backgroundStyle(cidx,item.canvasDatas.length)" v-for="(roleItem,cidx) in item.canvasDatas" 
						:key="('canvas_'+item.roleId+'_'+cidx)"
						:id="('canvas_'+item.roleId+'_'+cidx)"
						>
						<div class="h_main_xk clearfix" >
							<div class="h_main_xknr clearfix" >
								<draggable style="z-index: 1;">
									<transition-group name="flip-list" style="display: flex;flex-wrap:wrap;">
										<div class="h_main_xk_li" v-for="pi in roleItem" :key="pi.itemId">
											<div class="h_main_xk_li_t">
												<img :src="pi.imageUrl">
											</div>
											<p :style="nameStyle(pi.quality)">{{pi.itemName}}</p>
										</div>
									</transition-group>
									
								</draggable>
								
								
							</div>
							
						</div>
						<div class="h_main_zs" v-if="cidx==0"><img src="../images/md.png"></div>
						<div class="h_main_yzs" v-if="cidx==0"><img src="../images/md.png"></div>
					</div>
				</div>
				
			</div>
		</div>
		
		
	</div>
</template>

<script>
import { qqLogin,wxLogin,HpjyRoleList} from "../server";
import html2canvas from "html2canvas";
import draggable from "vuedraggable";
import { getStorageSync } from "../unitl/common";
import { constant } from "../unitl/constant";
import {hpjyData} from "../unitl/test.js"
function getItemCanvas(dom){
	var rect=dom.getBoundingClientRect();
	const scrollTop =document.documentElement.scrollTop || document.body.scrollTop;
	return html2canvas(dom, {
		imageTimeout: 10000000,
		useCORS: true,
		allowTaint:true,
		x: parseInt(rect.x)+10,
		y: Math.ceil(rect.y),
		scrollY: -scrollTop,
		width: Math.ceil(rect.width),
		height: Math.ceil(rect.height),
		backgroundColor:null
	})

}

export default {
    name: "Hpjy",
    data() {
        return {
            token:'',
			userId:"",
			openid:"",
			gameid:'20004',
			roleList:[],
			loading:false,
			showloading:false,
			showCreateLoading:false,
			showShuiyin:true,
			bg:'',
			qq:{},
			color:'',
			eCount:400,
			canvasIds:[],
			canvasHeight:0,
			canvasWidth:0,
			allCanvas:[]
        };
    },

    components: {
        draggable
    },
    watch: {
        pageIndex(val) {
            this.loadBackgounds(val);
        }
    },
    methods: {
		backgroundStyle(cidx,length){
			var backgroundImg='';
			var backgroundRepeat='';
			var bg=require('../assets/bg4.png');
			
			
			if(this.showShuiyin){
				backgroundImg=`url(${bg})`;
				backgroundRepeat='repeat-y';
			}
		
			let style={
				backgroundImage:backgroundImg,
				backgroundRepeat:backgroundRepeat,
				backgroundSize:'100%',
				backgroundColor:this.color
			}
			if(cidx==0){
				style.borderTop='14px solid #F5B417';
			}
			if(cidx==length-1){
				style.borderBottom='14px solid #F5B417';
			}
			return style;
		},

		
		allColor(){
			if(this.color){
				return {color:this.color};
			}
			return {};
		},
		nameStyle(quality){
			if(quality==6){
				//粉色
				return {
					color:'pink'
				}
			}
			if(quality==5){
				//紫色
				return {
					color:'#976bf6'
				}
			}
			if(quality==4){
				//蓝色
				return {
					color:'#36527d'
				}
			}
		},
		createEnd(){
			var canvas = document.createElement("canvas");
			var h=20,w=20;
	
			canvas.width = this.canvasWidth+w*2;
			canvas.height = this.canvasHeight+w*2;
			canvas.style.width='100%';
			canvas.style.background='#000';
			var ctx=canvas.getContext('2d');
			
			for(var i=0;i<this.allCanvas.length;i++){
				var t=this.allCanvas[i];
				ctx.drawImage(t, w, h, t.width, t.height);
				h+=t.height;
			}
			let link = document.createElement("a");
			link.href = canvas.toDataURL("image/jpeg");
			link.setAttribute("download", '和平精英_'+Date.now() + ".jpg");
			link.style.display = "none";
			document.body.appendChild(link);
			link.click();
			this.showCreate = true;
			this.showCreateLoading = false;
			// this.showloading = false;
		},
		createCanvas(idx){
			getItemCanvas(document.getElementById(this.canvasIds[idx])).then(canvas=>{
				var temp=idx+1;
				if(idx==0){
					this.canvasWidth=0;
					this.canvasHeight=0;
					this.allCanvas=[];
				}
				this.canvasHeight+=canvas.height;
				this.canvasWidth=Math.max(this.canvasWidth,canvas.width);
				this.allCanvas.push(canvas);
				if(temp<this.canvasIds.length){
					this.createCanvas(temp);
				}else{
					this.createEnd();
				}
			});
		},
		createImg() {
			if(this.showCreateLoading)return;
			this.showloading = true;
			this.showCreateLoading = true;
			this.createCanvas(0);
	
		},
		ptLogin(pt){
			location.href="http://p.laodas.com/ptlogin#&a=a#&md=hpjy&pt="+pt
		},
		wxLogin(params){
			wxLogin({
				code:params.code
			}).then(res=>{
				this.loginSuccess(res,res.data.appOpenid);
			})
		},
		initRoleList(roleList){
			
			var canvasIds=[];
			if(this.showShuiyin){
				canvasIds.push('logo');
			}
			
			for(var i in roleList){
				canvasIds.push('roleItem_'+roleList[i].roleId);
				
				roleList[i].depotdetail.list.sort(function(x,y){
					if(x.quality>y.quality){
						return -1;
					}else if(x.quality==y.quality){
						return 0;
					}else{
						return 1;
					}
				})
				roleList[i].yanse6=0;
				roleList[i].yanse5=0;
				roleList[i].yanse4=0;
				roleList[i].taozhuang=0;
				var canvasDatas=[];
				var eCanvasData=[];
				var cidx=0;
				for(var j in roleList[i].depotdetail.list){
					var item=roleList[i].depotdetail.list[j];
					if(eCanvasData.length>=this.eCount){
						canvasDatas.push(eCanvasData);
						eCanvasData=[];
						canvasIds.push('canvas_'+roleList[i].roleId+'_'+cidx);
						cidx+=1;
					}
					
					eCanvasData.push(item);
					if(item.quality==6){
						roleList[i].yanse6+=1;
					}
					if(item.itemName.indexOf('套装')!=-1){
						roleList[i].taozhuang+=1;
					}
				}
				if(eCanvasData.length>0){
					canvasDatas.push(eCanvasData);
					canvasIds.push('canvas_'+roleList[i].roleId+'_'+cidx);
				}
				roleList[i].canvasDatas=canvasDatas;
			}
			this.canvasIds=canvasIds;
			this.roleList=roleList;
		},
		getRoleList(){
			var userInfo=JSON.parse(getStorageSync(constant.userInfo)||'{}');
			if(userInfo&&userInfo.shuiyin){
				this.showShuiyin=false;
			}
			
			HpjyRoleList({
				token:this.token,
				userId:this.userId,
				openId:this.openid
			}).then(res=>{
				this.loading=false;
				var roleList=res.data[this.gameid];
				this.initRoleList(roleList);
				
				//quality =6 粉色 =5紫色  =4蓝色
				//console.log(JSON.stringify(this.roleList));
			})
		},
		loginSuccess(res,openid){
			this.userId=res.data.userId;
			this.token=res.data.token;
			this.openid=openid;
			this.qq=res.qq;
			
			console.log('userId',this.userId);
			console.log('token',this.token);
			console.log('openid',this.openid);
			console.log('qq',res.qq);
			
			
			this.getRoleList();
			
		},
		qqLogin(params){
			this.openid=params.openid;
			
			qqLogin({
				appOpenid:params.openid,
				openId:params.openid,
				payToken:params.pay_token,
				accessToken:params.access_token
			}).then(res=>{
				this.loginSuccess(res,this.openid);
			})
		},
		getParameter(){
			var obj = new Object();
			var str = window.location.href.split('?')[1];
			if(!str) return obj;
			var arrList = str.split('&');
			if(arrList.length>0){
				for(var i=0;i<arrList.length;i++){
					var arr = arrList[i].split('=')
					obj[arr[0]] = window.decodeURIComponent(arr[1])
				}
				
			}
			return obj;
		}
    },

    mounted() {
		var params=this.getParameter();
		if(params&&params.openid&&params.loginType=='qq'){
			this.loading=true;
			this.qqLogin(params);
		}
		if(params&&params.code&&params.loginType=='wx'){
			this.loading=true;
			this.wxLogin(params);
		}
		if(params.test==1){
			this.token='26Yh8Ysa';
			this.userId='720424413';
			this.openid='o7KEU0gKDK3gY5qJM8BtSqKYjxUo';
	
			
			this.initRoleList(hpjyData.data.data[20004])
		}
    }
};
</script>

<style scoped>
	.btn-item .m-colorPicker::before {
		content: "选择背景颜色";
		padding-right: 7px;
		color: #fff;
	}

h1 {
    margin-top: 80px;
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    line-height: 28px;
}
#testImg canvas{
	width: 80%;
}
.tips {
    padding-left: 20px;
    margin: 19px auto 0;
    width: 70px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(65, 194, 131, 1);
    line-height: 28px;
    background: url("../assets/green.png") left center no-repeat;
}
.h1{
	margin-top: 40px;
}
.loading-show{
    margin-top: 30px;
    color: #ffffff;
	font-size: 20px;
}


.btn-item {
    color: #fff;
    border-radius: 4px;
	padding:5px 10px;
    width: 130px;
    text-align: center;
    background: rgba(44, 82, 129, 1);
    margin: 10px;
    cursor: pointer;
}

@charset "utf-8";

/* CSS Document */
* {
	font-family: "微软雅黑";
	outline: none;
	font-size: 14px;
	color: #444444;
	list-style: none;
	line-height: 26px;
}

* {
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	-webkit-tap-highlight: rgba(0, 0, 0, 0);
	-webkit-text-size-adjust: none;
}

body, dl, dd, h1, h2, h3, h4, h5, h6, from {
	margin: 0;
}

img {
	max-width: 100%;
	display: block;
}

ol, ul, li, img {
	margin: 0;
	padding: 0;
	border: 0;
	outline: 0;
	vertical-align: baseline;
}

input, img, textarea {
	border: none;
	border-radius: 0;
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	-webkit-tap-highlight: rgba(0, 0, 0, 0);
	-webkit-text-size-adjust: none;
}

a {
	text-decoration: none;
	blr: expression(this.onFocus=this.blur()); /* IE Opera */
	outline: none; /* FF Opera */
}

a:focus {
	-moz-outline-style: none; /* FF */
}

img, input {
	border: 0;
}

input, textarea, select {
	outline: none;
}

a div, a span {
	cursor: pointer;
}

textarea {
	resize: none;
}

/*闃叉textarea鏀惧ぇ鏃讹紝涓変釜鏂滅嚎琚斁澶?*/
*, *:before, *:after {
	box-sizing: border-box;
	-webkit-box-sizing: border-box;
	-moz-box-sizing: border-box;
	-o-box-sizing: border-box;
}

html, body, ul, li, a, span, p {
	padding: 0;
	margin: 0;
	list-style: none;
	line-height: 22px;
	margin: 0px;
	padding: 0px
}

img {
	border: 0px;
}

.juzhong {
	width: 1250px;
	display: block;
	margin-left: auto;
	margin-right: auto;
}

.lfd {
	float: left;
	display: block;
}

.rfd {
	float: right;
	display: block;
}

h2, h3, h4, h5 {
	text-align: center;
}

p {
	font-family: "微软雅黑";
	line-height: 26px;
}

.gg {
	width: 1200px;
	margin-left: auto;
	margin-right: auto;
}

.clear {
	clear: both;
}

.clearfix:after {
	visibility: hidden;
	display: block;
	font-size: 0;
	content: " ";
	clear: both;
	height: 0;
}

.clearfix {
	*zoom: 1;
}

.fl {
	float: left;
}

.fr {
	float: right;
}

/* 和平精英样式开始 */
.h_wk {
	width: 100%;
	background: url('../images/hbg.jpg');
	background-repeat: no-repeat;
	background-position: center top;
	background-attachment: fixed;
	min-height: 1080px;
}

.h_main {
	width: 1400px;
	margin: 0px auto;
	overflow: hidden;
	background-color: #000;
	
}

.h_main_s_bbq {
	border: 1px solid #f6be02;
	text-align: center;
	padding: 2px 20px;
	margin-top: 30px;
}

.h_main_s_bbq span {
	color: #fff;
	font-size: 24px;
	line-height: 24px;
}

.h_main_s_zx {
	margin-top: 28px;
	margin-left: 55px;
	margin-right: 20px;
}

.h_main_s_yx {
	margin-top: 28px;
	margin-left: 50px;
}

.h_main_s_hp {
	margin-top: 12px;
}

.h_main_m{
	margin: 40px 0;
	text-align: left;
}
.h_main_m .span{
	font-size: 40px;
	font-weight: bold;
	color: #fff;
	margin-right: 20px;
}

.h_main_x {
	border-left: 14px solid #F5B417;
	border-right: 14px solid #F5B417;
	position: relative;
}

.h_main_xk {
	background: url('../images/h_nkbg.png');
	background-repeat: repeat;
	padding: 0;
}

.h_main_xk_li {
	width: 12.5%;
	margin-bottom: 30px;
	padding: 10px;
}

.h_main_xk_li:nth-child(7n) {
	margin-right: 0px;
}

.h_main_xk_li_t {
	width: 100%;
}

.h_main_xk_li_t img {
	width: 100%;
	object-fit: cover;
	padding: 10px;
	border-radius: 10px;
}

.h_main_xk_li p {
	text-align: center;
	font-size: 15px;
	color: #fff;
	font-weight: bold;
	margin-top: 10px;
}

.h_main_zs {
	position: absolute;
	left: -14px;
	top: -15px;
}

.h_main_yzs {
	position: absolute;
	right: -14px;
	top: -15px;
}




</style>
